import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripTag',
    standalone: false
})
export class StripTagPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    return value.replace(/<\/?[^>]+(>|$)|&[^;]+;/g, '');
  }
}
